import { ModalOverlay, type ModalOverlayProps } from 'react-aria-components';

import Lottie from '../lottie-player/LottiePlayer';

import { animationData } from './animation/MyStoreLoaderLeafyGreenAnimation';

const lottieStyles = {
  maxWidth: '140px',
  '@media (min-width: 600px)': {
    maxWidth: '200px',
  },
} as const;

type LoaderProps = {
  inner?: boolean;
  open?: boolean;
  testId?: string;
} & Omit<ModalOverlayProps, 'isOpen'>;

const Loader = ({ open = true, testId, ...others }: LoaderProps) => (
  <ModalOverlay
    isOpen={open}
    className='loader-overlay'
    style={{
      backgroundColor: '#FFFFFF',
      position: 'fixed',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    data-testid={testId ?? 'loader'}
    {...others}
  >
    <div style={lottieStyles}>
      <Lottie animationData={animationData} autoplay loop />
    </div>
  </ModalOverlay>
);

export default Loader;
